export const PROFILE_VISIBILITY_DRAWER_OPENED =
  'PROFILE_VISIBILITY_DRAWER_OPENED';

export const profileVisibilityDrawerOpened = () => ({
  type: PROFILE_VISIBILITY_DRAWER_OPENED,
});
